import gql from 'graphql-tag';

const GET_SPECIAL_NOTES = gql`
  query getSpecialNotes($query: JSON) {
    getSpecialNotes(query: $query){
      specialNotes
      leadScores
    }
  }
`;

export default GET_SPECIAL_NOTES;
